import React from 'react';
import { Card, Row, Col } from "react-bootstrap";
import Select from './Form/Select';

export default function OfferToolToggle(props) {

    const offerTypes = [
        {ID: 'glp1', NAME: "GLP-1"},
    ]

    return (
        <Card.Header>
            <Row>
                <Col md={8}>
                    <h4 className="title">{props.title}</h4>
                    {props.description && <p className="category">{props.description}</p> }
                </Col>
                <Col md={4} className="text-right">
                    <Select
                        value={props.value}
                        label="Offer"
                        name="offerType"
                        formValues={offerTypes}
                        useDefault={false}
                        onChange={props.onChange}
                        validate="string|required"
                        colSize="6"
                    />
                </Col>
            </Row>
        </Card.Header>
    );
}
